import gql from 'graphql-tag'

export const GET_SCHEDULER_LIST_QUERY = gql`
  query scheduler_list {
    scheduler_list @rest(type: "SchedulerList", path: "/scheduler-list") {
      id
      name
      status
      definition
      next_run_at
      last_updated_by
      updated_at
      entity_ids
      entity_type_ids
      result
    }
  }
`
